module.exports = __webpack_public_path__ + "img/staff-p-500.55f57d4d.png";